import { render, staticRenderFns } from "./templateInfoModal.vue?vue&type=template&id=28baf82c&scoped=true&"
import script from "./templateInfoModal.vue?vue&type=script&lang=js&"
export * from "./templateInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./templateInfoModal.vue?vue&type=style&index=0&id=28baf82c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28baf82c",
  null
  
)

export default component.exports